import classNames from "classnames";
import { AnimatedDiv } from "PFComponents/animated_div";
import Card from "PFComponents/card/card";
import React, { useEffect } from "react";
import { TransitionStatus } from "react-transition-group";

import { useMatchCardContext } from "../../match_card_context";
import { MatchCardBody } from "../match_card_body";
import { MatchCardHeader } from "../match_card_header";
import css from "./animated_match_card.module.scss";

type AnimatedMatchCardProps = {
  state: TransitionStatus;
};

export const AnimatedMatchCard = React.forwardRef<HTMLDivElement, AnimatedMatchCardProps>(
  ({ state }, ref) => {
    const { isOpen, animationTrigger, animate } = useMatchCardContext();

    useEffect(() => {
      animate();
    }, [isOpen, animate]);

    return (
      <Card ref={ref} bodyClassName={classNames(css.body, css[state])}>
        <AnimatedDiv trigger={animationTrigger}>
          <MatchCardHeader />
          <MatchCardBody />
        </AnimatedDiv>
      </Card>
    );
  }
);

AnimatedMatchCard.displayName = "Animated match card";
